import BaseList from 'records/BaseList';
import { SearchFilters } from 'records/SearchFilter'

import {
  SEARCH_PRODUCT_CATALOG_FILTER_MAINTAIN,
  SEARCH_PRODUCT_CATALOG_FILTER_RESET_STATE,
} from 'actions/searchProductCatalogFilter';

const initValues = [
  {
    itemType: 'Category',
    itemKey: 'mainCategoryName',
  },
  {
    itemType: 'Brand',
    itemKey: 'brand',
  },
  {
    itemType: 'Pack',
    itemKey: 'packSizePack',
  },
  {
    itemType: 'Size',
    itemKey: 'packSizeSize',
  },
  {
    itemType: 'Storage',
    itemKey: 'storageDesc',
  }
];

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new SearchFilters(initValues),
  sortKey: null,
});

const actionsMap = {
  [SEARCH_PRODUCT_CATALOG_FILTER_MAINTAIN]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [SEARCH_PRODUCT_CATALOG_FILTER_RESET_STATE]: (state, action) => {
    return initialState;
  },
};

export default function searchProductCatalogFilter(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
